import React, { useContext } from 'react';
import { Link, Outlet } from 'react-router-dom';
import { AuthContext } from '../contexts/AuthProvider';
import useAdmin from '../hooks/useAdmin';
import useBuyer from '../hooks/useBuyer';
import useSeller from '../hooks/useSeller';
import Navbar from '../Pages/Shared/Navbar/Navbar';

const AdminLayout = () => {
    const { user } = useContext(AuthContext);
    const [isAdmin] = useAdmin(user?.email);
    const [isSeller] = useSeller(user?.email)
    const [isBuyer] = useBuyer(user?.email)
    return (
        <div>
            <Navbar></Navbar>
            <div className="drawer drawer-mobile">
                <input id="dashboard-drawer" type="checkbox" className="drawer-toggle" />
                <div className="drawer-content">
                    <Outlet></Outlet>
                </div>
                <div className="drawer-side">
                    <label htmlFor="dashboard-drawer" className="drawer-overlay"></label>
                    <ul className="menu p-4 w-80 bg-base-100 text-base-content">
                        <li><Link to="/dashboard">Dashboard</Link></li>
                        {
                            isAdmin && <>
                                {/* <li><Link to="/admindashboard/allusers">All users</Link></li> */}
                                <li><Link to="/admindashboard/allbuyers">All Buyers</Link></li>
                                <li><Link to="/admindashboard/allseller">All Sellers</Link></li>

                            </>

                        }
                        {
                            isSeller && <>
                                {/* <li><Link to="/admindashboard/allusers">All users</Link></li> */}
                                <li><Link to="/sellerdashboard/addproduct">ADD Products</Link></li>
                                <li><Link to="/sellerdashboard/myproducts">My Products</Link></li>

                            </>
                        }
                        {
                            isBuyer && <>
                                {/* <li><Link to="/admindashboard/allusers">All users</Link></li> */}
                                <li><Link to="/buyerdashboard/myorder">My Orders</Link></li>
                                {/* <li><Link to="/sellerdashboard/myproducts">My Products</Link></li> */}

                            </>
                        }

                    </ul>

                </div>
            </div>
        </div>
    );
};

export default AdminLayout;